module.exports = __webpack_public_path__ + "static/wechat-807e8c0129cbe983eafec92d42b5cf42.jpg";